var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticStyle:{"background":"rgb(9, 22, 88)"}},[_c('Head'),_c('Menu')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }